/**
 * API for SavedState
 * @module api/primeStyles
 */

import Settings from "../settings";

const API_VERSION = "v1";

export const getPrimeStyles = contextId =>
  fetch(`${Settings.camioApiUrl}${API_VERSION}/primestyles/${contextId}`, {
    mode: "cors"
  }).then(response => {
    if (response.ok) {
      return response.json();
    }
    return Promise.reject({ error: "Error in getPrimeStyles" });
  });



// WEBPACK FOOTER //
// ./app/api/primeStyles.js